import { compose } from "recompose";
import { createStructuredSelector } from "reselect";
import * as hoc from "modules/user/auth/hoc";
import * as userSelectors from "modules/user/auth/selectors";
import * as profileSelectors from "modules/user/profile/selectors";
import { connect } from "react-redux";
import * as api from "modules/user/profile/api";
import { createErrorsSelector } from "core/helpers";
import { isOnboardedCandidate } from "modules/user/auth/model";
import View from "./View";

const isPhoneNumber = new RegExp("^[+][0-9]");

export default compose(
  hoc.authorized(isOnboardedCandidate),
  connect(
    createStructuredSelector({
      initialValues: userSelectors.fetchUserData,
      errors: createErrorsSelector(profileSelectors.editProfile),
      updateAvatarApi: profileSelectors.updateAvatar,
      editApi: profileSelectors.editProfile
    }),
    dispatch => ({
      onSubmitAvatar: values => {
        dispatch(api.updateAvatar.request({ photo: values.photo }));
      },
      onSubmit: ({ ...values }, { setErrors }) => {
        if (!isPhoneNumber.test(values.phone)) {
          return setErrors({
            phone: "Invalid phone format"
          });
        }
        dispatch(api.editProfile.request({ body: values }));
      }
    })
  )
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/EditProfile/Provider.js